import { SWReactIcons } from "@similarweb/icons";
import { ColumnsPickerLite, PlainTooltip, SearchInput } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import {
    Separator,
    Title,
} from "app/pages/website-analysis/audience-interests/single/AudienceInterestsTableTop/AudienceInterestsTableTopStyles";
import { SearchContainer } from "app/pages/workspace/StyledComponent";
import { PrimaryBoxTitle } from "pro-features/styled components/StyledBoxTitle/src/StyledBoxTitle";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import TableActionsCompetitiveContainer from "../../containers/TableActions/TableActionsCompetitiveContainer";
import getColumnsPickerLiteProps from "../../helpers/getColumnsPickerLiteProps";
import useCompetitiveFilter from "../../hooks/useCompetitiveFilter";
import useCompetitiveQueryParams from "../../hooks/useCompetitiveQueryParams";
import type { CompetitiveColumnType } from "../../types/common";
import { CompetitiveFilter } from "../CompetitiveFilter/CompetitiveFilter";

import { StyledColumnsPicker, StyledIcon } from "./styles";

type CompetitiveLandscapeTableHeaderProps = {
    isTrial?: boolean;
    tableColumns: readonly CompetitiveColumnType[];
    onClickToggleColumns: (selectedColumnIndex: number) => void;
};

export const CompetitiveLandscapeTableHeader = (props: CompetitiveLandscapeTableHeaderProps) => {
    const { isTrial, tableColumns, onClickToggleColumns } = props;
    const { selectedSite, availableFilters } = useCompetitiveQueryParams();
    const { onSearchTermFilterChange } = useCompetitiveFilter();

    return (
        <>
            <Title>
                <PrimaryBoxTitle>
                    {translate("si.website-analisys.tab.competitors", { site: selectedSite })}
                    <PlainTooltip
                        tooltipContent={translate("analysis.common.competitors.similar.title.tooltip", {
                            site: selectedSite,
                        })}
                    >
                        <StyledIcon>
                            <SWReactIcons
                                iconName="info"
                                size="xs"
                            />
                        </StyledIcon>
                    </PlainTooltip>
                </PrimaryBoxTitle>
            </Title>
            <Separator />
            <CompetitiveFilter />
            <SearchContainer>
                <SearchInput
                    disableClear={true}
                    disabled={isTrial}
                    defaultValue={availableFilters.domain?.value}
                    debounce={400}
                    onChange={onSearchTermFilterChange}
                    placeholder={translate("forms.search.placeholder")}
                />
                <StyledColumnsPicker>
                    <FlexRow>
                        <div>
                            <ColumnsPickerLite
                                {...getColumnsPickerLiteProps({
                                    tableColumns,
                                    onClickToggleColumns,
                                })}
                                translations={{
                                    tooltip: translate("workspace.sales.column.picker"),
                                    getSelectedAmountText: ({ selectedValue, totalValue }) =>
                                        translate("common.columnsPicker.selectedAmount", {
                                            selected: selectedValue,
                                            total: totalValue,
                                        }),
                                    mandatoryField: translate("common.columnsPicker.mandatoryField"),
                                    apply: translate("common.apply"),
                                }}
                            />
                        </div>
                    </FlexRow>
                </StyledColumnsPicker>
            </SearchContainer>
            <TableActionsCompetitiveContainer />
        </>
    );
};
